import { Skeleton } from "@/components/other";
import { Typography } from "@/components/text";
import { pluralize } from "@/libraries/helper";
import isEmpty from "lodash/isEmpty";
import { Suspense, lazy } from "react";

const MessageItem = lazy(() => import("./Item"));

export interface MarkdownMessageProps extends React.ComponentProps<"article"> {
	variant?: "chats" | "cases";
	text: string;
	members?: { id: number; name: string }[];
	removeMemberIds?: number[];
	keyword?: string;
	lineClamp?: 1 | 2 | 3 | 4 | 5 | 6;
	isStrike?: boolean;
	isDeleted?: boolean;
	documentCount?: number;
	isMe?: boolean;
	onTextRender?: (isCanShowMore: boolean) => void;
}

const MarkdownMessage: React.FC<MarkdownMessageProps> = (props) => {
	const {
		text,
		variant = "cases",
		isDeleted = false,
		documentCount = 0,
	} = props;

	if (isDeleted) {
		return (
			<Typography
				fontWeight={500}
				fontSize={14}
				className="prose prose-sm max-w-none italic"
			>
				This message was deleted
			</Typography>
		);
	}

	if (documentCount && !text) {
		return (
			<Typography
				fontWeight={500}
				fontSize={14}
				className="prose prose-sm max-w-none"
			>
				{pluralize({
					count: documentCount,
					singularText: variant === "cases" ? "File message" : "Media message",
					isIncludeNumber: false,
				})}
			</Typography>
		);
	}

	if (!isEmpty(text)) {
		return (
			<Suspense fallback={<Skeleton className="w-full h-6" />}>
				<MessageItem {...props} />
			</Suspense>
		);
	}

	return null;
};

export default MarkdownMessage;
